import extend from 'lodash/extend';
import set from 'lodash/set';
import get from 'lodash/get';
import Vue from 'vue'

const BRAND_COLOR = '#007BFF';
const WHITE = '#FFFFFF';
const BORDER_COLOR = '#ECECEC';
const TEXT_COLOR = '#333333';

export default class WhitelabelConfig {
  constructor(config) {
    extend(this, config);

    this._init('domain', null);
    this._init('company_name', null);
    this._init('about', null);

    this._initAsset('logo', null);
    this._initAsset('banner', null);
    this._initAsset('favicon', null);

    this._initMeta('ga_code', null);
    this._initMeta('fb_pixel_id', null);
    this._initMeta('google_verification', null);
    this._initMeta('fb_domain_verification', null);

    this._initStyle('bg_color', WHITE);
    this._initStyle('brand_color', BRAND_COLOR);
    this._initStyle('text_color', TEXT_COLOR);

    this._initStyle('header.bg_color', WHITE);
    this._initStyle('header.border_color', BORDER_COLOR);
    this._initStyle('links.text_color', TEXT_COLOR);

    this._initStyle('inputs.bg_color', WHITE);
    this._initStyle('inputs.border_color', TEXT_COLOR);
    this._initStyle('inputs.border_radius', '0');
    this._initStyle('inputs.label_color', TEXT_COLOR);
    this._initStyle('inputs.text_color', TEXT_COLOR);
  }

  _init(property, value) {
    this[property] = this[property] || value;
  }

  _initStyle(property, value) {
    if (!this.styles) {
      this.styles = {};
    }

    set(this.styles, property, get(this.styles, property) || value);
  }

  _initAsset(property, value) {
    if (!this.assets) {
      this.assets = {};
    }

    this.assets[property] = this.assets[property] || value;
  }

  _initMeta(property, value) {
    if (!this.meta) {
      this.meta = {};
    }

    Vue.set(this.meta, property, this.meta[property] || value);
  }
};